export const de = {
    LEFT: 'Links: geht zum vorherigen Tag.',
    RIGHT: 'Rechts: Verschieben auf den nächsten Tag.',
    DOWN: 'Unten: Verschieben Sie in die nächste Zeile.',
    UP: 'Oben: wechseln zur vorherigen Zeile.',
    PGUP: 'Bild: Bewegen zum vorherigen Monat.',
    PGDOWN: 'Bild↓: Bewegen Sie sich auf den nächsten Monat.',
    HOME: 'Home: wechseln zu dem vorherigen Jahr.',
    END: 'Ende: Verschieben auf das nächste Jahr.',
    ESC: 'Esc//Heute / close: Schließen des Kalenders.',
    TITLE: 'Tastatur-Anleitung'
};
